import ItemProduct from './components/ItemProduct';
import ItemPublish from './components/ItemPublish';
import LayoutListHorizontal from './components/LayoutListHorizontal';
import LayoutPublish from './components/LayoutPublish';
import SectionItemList from './components/SectionItemList';
import SectionBanner from './components/SectionBanner';
import SectionBrands from './components/SectionBrands';
import SectionCategories from './components/SectionCategories';
import SectionBannerPromo from './components/SectionBannerPromo';

export const FIND_LOCAL = 'FIND_LOCAL';
export const FIND_DB = 'FIND_DB';
export const FIND_SUCCESS = 'FIND_SUCCESS';
export const FIND_ERROR = 'FIND_ERROR';

export const COMPONENTS = {
  ItemProduct,
  ItemPublish,
  LayoutListHorizontal,
  LayoutPublish,
  SectionItemList,
  SectionBanner,
  SectionBrands,
  SectionCategories,
  SectionBannerPromo,
};
